import axios from "axios";
import GlobalSession, {
  getToken,
  ShowErrorAlert,
} from "../views/Common/GlobalSession";
export const getEntityBioApi = async (id) => {
  try {
    // Get the authentication token
    var randomnumber = Math.floor(Math.random() * 100);
    let tokenStr = getToken();
    // headers: {"Authorization" : `Bearer ${tokenStr}`}
    const response = await axios({
      method: "GET",
      url:
        process.env.REACT_APP_API_END_POINT +
        "/getEntityBio/" +
        id +
        "?v=" +
        randomnumber,
      // data: {"id":obj.id},
      //config: { headers: {'Content-Type': 'multipart/form-data' }}
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        //console.log(res.data);
        return res.data;
      });
    return response;
  } catch (e) {
    console.log(e);
    if (e.response && e.response.status === 401) {
      ShowErrorAlert(4, e.response.data.error.message);
    }
  }
};
export const updateEntityBioApi = async (obj) => {
  try {
    // Get the authentication token

    // headers: {"Authorization" : `Bearer ${tokenStr}`}
    let tokenStr = getToken();
    const response = await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/updateEntityBio",
      data: { entityId: GlobalSession.entityId, summary: obj.summary },
      //config: { headers: {'Content-Type': 'multipart/form-data' }}
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        //console.log(res.data);
        return res.data;
      });
    return response;
  } catch (e) {
    console.log(e);
    if (e.response && e.response.status === 401) {
      ShowErrorAlert(4, e.response.data.error.message);
    }
  }
};
export default getEntityBioApi;
